module.exports = __webpack_public_path__ + "static/media/openflowFirst@2x.b9d5d073.png";